import { render, staticRenderFns } from "./ModalEspaceClient.vue?vue&type=template&id=5ac9fb4f&scoped=true&"
import script from "./ModalEspaceClient.vue?vue&type=script&lang=js&"
export * from "./ModalEspaceClient.vue?vue&type=script&lang=js&"
import style0 from "./ModalEspaceClient.vue?vue&type=style&index=0&id=5ac9fb4f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac9fb4f",
  null
  
)

export default component.exports